/* Already Loved Club — "Scratch the Tag" email capture. v2.

   Ported from the EZ Bombs ark-lp game-scratcher. What carried over is the game
   itself: a canvas painted over the prize, erased with destination-out arcs, and
   a sampled cleared-percentage threshold that triggers the reveal.

   What deliberately did NOT carry over is the claim path. EZ Bombs scratches
   straight to /discount/CODE?redirect= and captures no email at all — it is a
   discount delivery mechanism, not a list-building one. Here the reveal opens an
   email gate, and the reward is only confirmed after Shopify confirms the
   contact saved.

   The submit MUST be a native {% form 'customer' %} post. fetch()-ing /contact
   on this store returns 403 (verified in a real browser, every content type,
   warmed session or not); the popup that did that showed a success view anyway
   and silently lost every signup for a full launch. Success here is shown only
   on Shopify's own confirmation, and every step is instrumented so a regression
   is visible in PostHog within a day instead of being guessed at.

   v2 adds the clarity work from Ricki's review: the tag face now reads
   "FULL PRICE" struck through (so what scratching DOES is obvious), a short
   auto-demo stroke plays on open, the hint text tracks progress, and the
   two-step rail advances. */
(function () {
  'use strict';

  var root = document.querySelector('[data-alcscr]');
  if (!root || root.dataset.alcscrInit) return;
  root.dataset.alcscrInit = '1';

  // Portal to <body> so no ancestor stacking context (sticky header, any
  // transformed wrapper) can trap the overlay. See the box-sizing note in the CSS.
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var KEY_SEEN     = 'alc_scratch_seen';
  var KEY_DONE     = 'alc_scratch_done';
  var KEY_REVEALED = 'alc_scratch_revealed';

  var force = /[?&]alcscratch=1/.test(window.location.search);

  var code       = (root.getAttribute('data-code') || '').trim();
  var delayMs    = (parseInt(root.getAttribute('data-delay'), 10) || 9) * 1000;
  var suppressMs = (parseInt(root.getAttribute('data-suppress'), 10) || 14) * 864e5;
  var threshold  = (parseInt(root.getAttribute('data-threshold'), 10) || 42) / 100;
  var hintStart  = root.getAttribute('data-hint-start') || '';
  var hintMid    = root.getAttribute('data-hint-mid') || '';
  var hintAfter  = root.getAttribute('data-hint-after') || '';

  var tag    = root.querySelector('[data-alcscr-tag]');
  var canvas = root.querySelector('[data-alcscr-canvas]');
  var hint   = root.querySelector('[data-alcscr-hint]');
  var gate   = root.querySelector('[data-alcscr-gate]');
  var formEl = root.querySelector('[data-alcscr-form], form.alcscr__form');
  var emailEl= root.querySelector('.alcscr__email');
  var errEl  = root.querySelector('[data-alcscr-err]');
  var step1  = root.querySelector('[data-alcscr-step="1"]');
  var step2  = root.querySelector('[data-alcscr-step="2"]');
  var step1n = root.querySelector('[data-alcscr-stepn="1"]');
  var ctx    = canvas && canvas.getContext('2d');
  if (!tag || !canvas || !ctx) return;

  // The corner offer pill is the minimised state of whichever capture is
  // running. It lives OUTSIDE this overlay (in the footer), and its reopen
  // handler used to live in alc-popup.js — so it has to be adopted here or
  // dismissing the scratcher leaves a dead control on the page.
  var pill = document.querySelector('[data-alc-pill]');

  var revealed = false, drawing = false, sized = false;
  var scratchFired = false, touched = false, midShown = false;

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };

  // ?alcscratch=1 is the review affordance: open immediately and wipe the
  // per-visitor state so the game can be replayed from the top instead of
  // resuming half-scratched or being suppressed for 14 days.
  if (force) { store.del(KEY_REVEALED); store.del(KEY_DONE); store.del(KEY_SEEN); }

  function track(name, props) {
    try { if (window.posthog && posthog.capture) posthog.capture(name, props || {}); } catch (e) {}
  }

  /* Shopify confirms a saved contact one of three ways depending on whether the
     return_to hint is honoured. Accept any of them; never infer success. */
  var posted = !!root.querySelector('[data-alcscr-posted]') ||
               /[?&]alcscratch=done/.test(window.location.search) ||
               /[?&]customer_posted=true/.test(window.location.search);
  var hasError = !!(errEl && !errEl.hasAttribute('hidden'));

  function showView(name) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-alcscr-view]'), function (v) {
      v.classList.toggle('is-active', v.getAttribute('data-alcscr-view') === name);
    });
  }

  function open(view) {
    if (view) showView(view);
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    store.set(KEY_SEEN, String(Date.now()));
    if (pill) pill.hidden = true;
    if (!sized) resize();
    track('scratch_shown', { view: view || 'offer' });
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 260);
    // Dismiss minimises rather than destroys — unless they already converted.
    if (pill && !store.get(KEY_DONE)) pill.hidden = false;
    track('scratch_dismissed', { revealed: revealed });
  }

  // Reopen from the pill. Matches the whole pill, not just the inner <a>: it
  // carries padding and goes full-width on mobile. The dismiss X is excluded so
  // closing it doesn't also reopen the overlay.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-alc-pill]') || e.target.closest('[data-alc-pillx]')) return;
    e.preventDefault();
    open(store.get(KEY_DONE) ? 'done' : 'offer');
    if (!revealed && store.get(KEY_REVEALED)) doReveal(false);
  });

  function suppressed() {
    if (force || posted || hasError) return false;
    if (store.get(KEY_DONE)) return true;                 // already on the list
    var seen = parseInt(store.get(KEY_SEEN) || '0', 10);
    return seen && (Date.now() - seen) < suppressMs;
  }

  /* ---------- the tag surface ---------- */

  function resize() {
    var rect = tag.getBoundingClientRect();
    if (!rect.width) return;
    var dpr = Math.max(1, window.devicePixelRatio || 1);
    canvas.width  = rect.width * dpr;
    canvas.height = rect.height * dpr;
    canvas.style.width  = rect.width + 'px';
    canvas.style.height = rect.height + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    paintTag(rect.width, rect.height);
    sized = true;
  }

  /* Kraft price tag — the artifact the brand actually sells against, replacing
     the EZ Bombs red foil + bomb icon. The struck-through "FULL PRICE" is the
     clarity fix: the tag itself says what scratching it will do. */
  function paintTag(w, h) {
    ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, w, h);

    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#cdbda1');
    g.addColorStop(0.5, '#c4b294');
    g.addColorStop(1, '#b9a788');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);

    // Paper fibre + flecks — board stock, not foil.
    for (var i = 0; i < 430; i++) {
      ctx.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.05).toFixed(3) + ')';
      ctx.fillRect(Math.random() * w, Math.random() * h, Math.random() * 26 + 4, 0.9);
    }
    for (var j = 0; j < 240; j++) {
      ctx.fillStyle = 'rgba(88,72,50,' + (Math.random() * 0.05).toFixed(3) + ')';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.3, 1.3);
    }

    // Tag rule + punched hole.
    ctx.strokeStyle = 'rgba(62,50,34,.22)';
    ctx.lineWidth = 1;
    ctx.strokeRect(9.5, 9.5, w - 19, h - 19);
    ctx.beginPath();
    ctx.arc(w / 2, 25, 7, 0, Math.PI * 2);
    ctx.fillStyle = '#fffdf8';
    ctx.fill();
    ctx.strokeStyle = 'rgba(62,50,34,.34)';
    ctx.stroke();

    ctx.textAlign = 'center';

    ctx.fillStyle = 'rgba(46,37,25,.5)';
    ctx.font = '300 8px Jost, sans-serif';
    ctx.fillText('A L R E A D Y   L O V E D   C L U B', w / 2, h / 2 - 26);

    // "FULL PRICE", struck through.
    ctx.fillStyle = 'rgba(46,37,25,.72)';
    ctx.font = 'italic 600 27px "Cormorant Garamond", Georgia, serif';
    var label = 'Full Price';
    ctx.fillText(label, w / 2, h / 2 + 4);
    var tw = ctx.measureText(label).width;
    ctx.strokeStyle = 'rgba(46,37,25,.6)';
    ctx.lineWidth = 1.4;
    ctx.beginPath();
    ctx.moveTo(w / 2 - tw / 2 - 8, h / 2 + 1);
    ctx.lineTo(w / 2 + tw / 2 + 8, h / 2 - 7);
    ctx.stroke();

    ctx.fillStyle = 'rgba(46,37,25,.55)';
    ctx.font = '300 8.5px Jost, sans-serif';
    ctx.fillText('S C R A T C H   H E R E', w / 2, h / 2 + 32);
  }

  // Webfonts often are not ready when the canvas first paints, which silently
  // falls back to Georgia/sans. Repaint once they land.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { if (!revealed && sized) resize(); });
  }

  function pos(e) {
    var r = canvas.getBoundingClientRect(), x, y;
    if (e.touches && e.touches.length) { x = e.touches[0].clientX - r.left; y = e.touches[0].clientY - r.top; }
    else { x = e.clientX - r.left; y = e.clientY - r.top; }
    return { x: x, y: y };
  }

  function scratchAt(x, y) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.arc(x, y, 21, 0, Math.PI * 2);
    ctx.fill();
  }

  function pctCleared() {
    var w = canvas.width, h = canvas.height, data;
    var dpr = Math.max(1, window.devicePixelRatio || 1), step = 6 * dpr;
    try { data = ctx.getImageData(0, 0, w, h).data; } catch (e) { return 0; }
    var total = 0, cleared = 0;
    for (var y = 0; y < h; y += step) {
      for (var x = 0; x < w; x += step) {
        total++;
        if (data[(y * w + x) * 4 + 3] < 60) cleared++;
      }
    }
    return total ? cleared / total : 0;
  }

  /* A short automatic stroke on open. Without it a scratch surface just looks
     like a static graphic — this is the single clearest signal that it comes off. */
  function demoStroke() {
    if (revealed || touched) return;
    var rect = tag.getBoundingClientRect();
    if (!rect.width) return;
    var x0 = rect.width * 0.20, y0 = rect.height * 0.78;
    var x1 = rect.width * 0.44, y1 = rect.height * 0.62;
    var n = 0, N = 22;
    (function step() {
      if (touched || revealed) return;
      n++;
      var p = n / N;
      scratchAt(x0 + (x1 - x0) * p, y0 + (y1 - y0) * p);
      if (n < N) requestAnimationFrame(step);
    })();
  }

  function markTouched() {
    if (touched) return;
    touched = true;
    tag.classList.add('is-touched');
  }

  function start(e) {
    markTouched();
    drawing = true;
    if (!scratchFired) { scratchFired = true; track('scratch_started', {}); }
    move(e);
  }
  function move(e) {
    if (!drawing || revealed) return;
    e.preventDefault();
    var p = pos(e);
    scratchAt(p.x, p.y);
  }
  function end() {
    if (!drawing) return;
    drawing = false;
    if (revealed) return;
    // getImageData is expensive, so progress is only sampled when the stroke
    // ends rather than on every move.
    var pct = pctCleared();
    if (pct >= threshold) { doReveal(true); return; }
    if (!midShown && pct > 0.12 && hint && hintMid) { midShown = true; hint.textContent = hintMid; }
  }

  function doReveal(animate) {
    revealed = true;
    markTouched();
    store.set(KEY_REVEALED, '1');
    canvas.classList.add('is-gone');
    if (!animate) canvas.style.opacity = '0';
    if (hint) hint.textContent = hintAfter;
    if (gate) gate.classList.add('is-open');
    if (step1) { step1.classList.remove('is-active'); step1.classList.add('is-done'); }
    if (step1n) step1n.innerHTML = '&#10003;';
    if (step2) step2.classList.add('is-active');
    track('scratch_revealed', {});
    if (animate) shavings();
    // Autofocusing on touch pops the keyboard and scroll-jumps the overlay
    // before the reward has even been read.
    if (!('ontouchstart' in window) && emailEl) {
      setTimeout(function () { try { emailEl.focus({ preventScroll: true }); } catch (e) {} }, 480);
    }
  }

  tag.addEventListener('mousedown', start);
  tag.addEventListener('mousemove', move);
  window.addEventListener('mouseup', end);
  tag.addEventListener('touchstart', start, { passive: false });
  tag.addEventListener('touchmove', move, { passive: false });
  tag.addEventListener('touchend', end);
  window.addEventListener('resize', function () { if (!revealed) resize(); });

  /* ---------- returning from the native submit ---------- */
  if (posted) {
    store.set(KEY_DONE, '1');
    if (pill) pill.hidden = true;                 // converted — never offer again
    track('scratch_subscribed', { discount_code: code || null });
    if (code) {
      // Puts the code on the session so checkout has it pre-applied.
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    }
    setTimeout(function () { open('done'); }, 400);
  } else if (hasError) {
    track('scratch_error', { message: (errEl.textContent || '').trim().slice(0, 120) });
    setTimeout(function () { open('offer'); doReveal(false); }, 300);
  } else if (!suppressed()) {
    setTimeout(function () {
      open('offer');
      // A visitor who scratched but did not submit shouldn't have to scratch
      // again on the next page view.
      if (store.get(KEY_REVEALED)) doReveal(false);
      else setTimeout(demoStroke, 620);
    }, force ? 150 : delayMs);
  }

  /* ---------- validate, then let the browser submit for real ---------- */
  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      var email = ((emailEl && emailEl.value) || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        e.preventDefault();                        // block ONLY when actually invalid
        if (errEl) { errEl.hidden = false; errEl.textContent = 'Please enter a valid email address.'; }
        track('scratch_invalid_email', {});
        return;
      }
      if (errEl) errEl.hidden = true;
      track('scratch_email_submitted', {});
      // Shopify's post-submit redirect drops the query string, which would bounce
      // a reviewer out of an unpublished preview theme and show them the LIVE
      // design for the confirmation state. Carry the preview id across the hop.
      try {
        var rt = formEl.querySelector('input[name="return_to"]');
        var pv = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (rt && pv) rt.value += '&preview_theme_id=' + encodeURIComponent(pv);
      } catch (_) {}
      // Disabling the submitter SYNCHRONOUSLY inside a submit handler makes
      // Chrome abandon the submission entirely — no network request at all.
      // Defer it so the navigation is already under way.
      var btn = formEl.querySelector('.alcscr__cta');
      if (btn) setTimeout(function () { btn.disabled = true; btn.textContent = 'SENDING…'; }, 0);
      // No preventDefault beyond this point: the native POST is the only path
      // Shopify accepts.
    });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-alcscr-close]')) { e.preventDefault(); close(); return; }

    var copy = e.target.closest('[data-alcscr-copy]');
    if (copy) {
      var c = copy.getAttribute('data-alcscr-copy');
      var done = function () {
        var t = copy.textContent;
        copy.textContent = 'COPIED';
        setTimeout(function () { copy.textContent = t; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(c).then(done, done);
      else done();
      track('scratch_code_copied', { discount_code: c });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* Tag shavings, not confetti. The EZ Bombs burst is 90 primary-colour
     particles; that reads as a slot machine. This is a short, muted fall of
     board-stock flecks in the brand palette. */
  function shavings() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var c = document.createElement('canvas');
    c.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147482200';
    document.body.appendChild(c);
    var cx = c.getContext('2d');
    function fit() { c.width = window.innerWidth; c.height = window.innerHeight; }
    fit();
    window.addEventListener('resize', fit);

    var colors = ['#c4b294', '#b9a788', '#a8896a', '#e7e1d3', '#232220'];
    var r = tag.getBoundingClientRect();
    var ps = [];
    for (var i = 0; i < 46; i++) {
      var a = Math.random() * Math.PI * 2, sp = 1.2 + Math.random() * 3.4;
      ps.push({
        x: r.left + Math.random() * r.width,
        y: r.top + Math.random() * r.height,
        vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 2.2,
        w: 2 + Math.random() * 3.5, h: 1 + Math.random() * 2,
        color: colors[i % colors.length],
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.22
      });
    }
    var frame = 0, TOTAL = 96;
    (function tick() {
      frame++;
      cx.clearRect(0, 0, c.width, c.height);
      cx.globalAlpha = Math.max(0, 1 - frame / TOTAL);
      ps.forEach(function (p) {
        p.vy += 0.16; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        cx.save(); cx.translate(p.x, p.y); cx.rotate(p.rot);
        cx.fillStyle = p.color; cx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        cx.restore();
      });
      if (frame < TOTAL) requestAnimationFrame(tick);
      else { window.removeEventListener('resize', fit); c.remove(); }
    })();
  }
})();
